module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cloudhsm-2014-05-30.paginators.json
// module id = 581
// module chunks = 4